import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import Header from '../layout/Header';

class ScrollItem__Legales extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller)
        this.onShow = () => {
            Header.hideBlur();
        };
        this.onHide = () => {
            Header.showBlur();
        };
    }
}

Scroll._registerClass('Legales', ScrollItem__Legales);

export default ScrollItem__Legales;
